/**
 * Push platform yetenek mantığı (SAF — Firebase importu YOK, test edilebilir).
 *
 * iOS web-push YALNIZ Ana Ekran'a kurulu PWA'da (iOS 16.4+) çalışır. iOS Safari
 * TAB'ında Notification/PushManager API'leri VAR ama bildirim asla teslim
 * EDİLMEZ → izin boşa yakılır. Bu durumu "desteklenmiyor" say.
 */

export function isIosSafariTab(): boolean {
  try {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    const platform = (navigator as any).platform || "";
    const isIos =
      /iPad|iPhone|iPod/.test(ua) ||
      (platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1);
    if (!isIos) return false;
    const standalone =
      (navigator as any).standalone === true ||
      (typeof window !== "undefined" &&
        window.matchMedia?.("(display-mode: standalone)")?.matches === true);
    return !standalone; // iOS + kurulu DEĞİL → push teslim edilmez
  } catch {
    return false;
  }
}

export interface PushSupportEnv {
  isIosTab: boolean;
  hasNotification: boolean;
  hasServiceWorker: boolean;
  hasPushManager: boolean;
}

/** SAF karar: tüm API'ler var VE iOS-Safari-tab değil → destekli. */
export function computePushSupported(env: PushSupportEnv): boolean {
  if (env.isIosTab) return false;
  return env.hasNotification && env.hasServiceWorker && env.hasPushManager;
}
